import jsPDF from 'jspdf';

export default {
  exportToPdf({
    state: { format, margin, orientation, spacing },
    getters: { fitsFormatHeight, fitsFormatWidth, getImageRealSize, pageDimensions },
    rootState: { generatedItems },
    rootGetters: { hasGeneratedItems }
  }) {
    if (!hasGeneratedItems) {
      return
    }

    const doc = new jsPDF({
      unit: 'mm',
      format,
      orientation
    })

    let positionX = margin

    let positionY = margin

    doc.setFont('helvetica')

    doc.setFontType('regular')

    doc.setFontSize(10)

    doc.setTextColor('red')

    const textAdviceX = margin

    const textAdviceY = pageDimensions.height - margin

    const addTextAdvice = () => {
      const textAdvice = 'Dicas para obter uma boa impressão: '
        + 'respeite as margens e sempre imprima com 100% do tamanho de impressão. '
        + 'Cada carta mede aproximadamente 63,5mm x 88mm.'

      doc.text(textAdviceX, textAdviceY, textAdvice)
    }

    addTextAdvice()

    let index = 1
    let page = 1

    for (const uuid in generatedItems) {
      const { image } = generatedItems[uuid]

      const { width, height } = getImageRealSize(image)

      const fitsWidth = fitsFormatWidth(positionX + width)

      console.log('Imagem ', index++)

      console.log('positionX + width <= availableWidth', positionX + width, pageDimensions.availableWidth, positionX + width <= pageDimensions.availableWidth)

      console.log('positionY + height <= availableHeight', positionY + height, pageDimensions.availableHeight, positionY + height <= pageDimensions.availableHeight)

      const fitsHeight = fitsFormatHeight(positionY + height)

      if (!fitsWidth && !fitsHeight) {
        doc.addPage(format, orientation)
        page++

        addTextAdvice()

        positionX = margin

        positionY = margin
      } else if (!fitsWidth && fitsHeight) {
        positionX = margin

        positionY += (height + spacing)
      }

      console.log({page, positionX, positionY})

      doc.addImage(image.url, 'JPEG', positionX, positionY, width, height)

      positionX += (width + spacing)
    }

    const dateString = new Date().toISOString()

    doc.save(`artefatos_${format}_${dateString}.pdf`)
  }
}